import { getData } from '@/views/mped/services/mped-service';

export const getDepartments = async ({ ids, type } = {}) => {
  return getData({
    url: '/department',
    uuid: 'a875bb5e-a6a4-481b-80db-21bb9de9a905',
    args: { ids, type },
    dictionary: `departments${type && `_${type}` || ''}`,
  });
};

export const getCountrySubjects = async () => {
  return getData({
    url: '/department/country/subject',
    uuid: '02e799a7-e336-4ea0-85f6-bbbd4fd735c4',
    dictionary: `countrySubjects`,
  });
};
